import {RouterView} from './RouterView.js';
const IndexRegister   = _ => import(/* webpackChunkName: "js/split/IndexRegister", webpackPreload: true */ '@/components/views/register/IndexRegister');
const AdvisorRegister = _ => import(/* webpackChunkName: "js/split/AdvisorRegister", webpackPreload: true */ '@/components/views/advisors/AdvisorRegister');
const ActivateAccount = _ => import(/* webpackChunkName: "js/split/ActivateAccount", webpackPreload: true */ '@/components/views/advisors/ActivateAccount');



export default {
	path: '/registro',
	component: RouterView,
	children: [
		{
			path: 'becarios',
			component:  IndexRegister,
			name: 'youngRegister',
			meta: {
				onlyGuest: true,
			}
		},
		{
			path: 'tutores',
			component:  IndexRegister,
			name: 'tutorRegister',
			meta: {
				onlyGuest: true,
			}
		},
		{
			path: 'tutores/nuevo',
			component: AdvisorRegister,
			name: 'AdvisorsRegister',
			meta: {
				onlyGuest: true,
			}
		},
		{
			path: 'tutores/info',
			component: ActivateAccount,
			name: 'ActivateAccount2',
			meta: {
				onlyGuest: true,
			}
		},
		{
			path: 'becario/info',
			component: ActivateAccount,
			name: 'ActivateAccount',
			meta: {
				onlyGuest: true,
			}
		},
		
	],

}
